export default __webpack_public_path__ + "static/media/mobView1.130cd02c.png";